// Matches the /coaches/search grid (`spacing={2}` => 16px between cards).
export const COACH_RAIL_SPACING = 16

// Three ~320px cards + two 16px gaps: the same card width as /coaches/search
// (DIRECTORY_RESULTS_MAX_WIDTH 1008 minus its 8px item padding).
export const COACH_RAIL_MAX_WIDTH = 992

export const COACH_RAIL_SLIDER_CONFIG = {
  slides: { perView: 3, spacing: COACH_RAIL_SPACING },
  breakpoints: {
    '(max-width: 700px)': {
      slides: { origin: 'center', perView: 1, spacing: COACH_RAIL_SPACING },
    },
    '(min-width: 701px) and (max-width: 960px)': {
      slides: { perView: 2, spacing: COACH_RAIL_SPACING },
    },
  },
  renderMode: 'performance',
}

/** Slides are flex containers so every `CoachCardOptimized` stretches to the tallest card. */
export const COACH_RAIL_SLIDE_STYLES = {
  height: 'auto',
  display: 'flex',
  '& > *': {
    flex: '1 1 auto',
    minWidth: 0,
  },
}

/** Caps the rail at the directory card width and clips extra slides once the rail is no longer a mobile swipe peek. */
export const COACH_RAIL_CONTAINER_STYLES = {
  maxWidth: COACH_RAIL_MAX_WIDTH,
  marginLeft: 'auto',
  marginRight: 'auto',
  '@media (min-width: 701px)': {
    overflow: 'hidden',
  },
}
